export default {
    buttons: {
        back: "Rug",
        next: "Volgende",
        submit: "Indienen"
    }
}